/**
 * Browser ↔ hen-site BFF contract for the v5 lead submit route, as the
 * `lead.submit` handler uses it. Mirrors `@highereducation/delivery-system`
 * `leadSubmitV5Contract`; keep the two identical.
 */

export const LEAD_SUBMIT_V5_PATH = '/api/hen/v5/delivery-service/lead/submit';

/** Cap on the author-supplied `attributes` map (1,400 matches the Cars comments limit). */
export const LEAD_SUBMIT_V5_ATTRIBUTES_CAP = {
  maxKeys: 20,
  maxKeyLength: 64,
  maxValueLength: 1400,
} as const;

export type LeadSubmitV5BffRequest = {
  organizationId: string;
  offeringId?: string;
  conversionId?: string;
  lead: {
    firstName: string;
    lastName: string;
    email: string;
    /** Digits only. */
    phoneNumber?: string;
  };
  attributes?: Record<string, string>;
  trackingContext: Record<string, unknown>;
};

/** `field` is a lead key or `attributes.<key>`. */
export type LeadSubmitV5FieldError = {
  field: string;
  message: string;
};

export type LeadSubmitV5ErrorCode =
  | 'field_validation'
  | 'invalid_request'
  | 'operator_error'
  | 'upstream_error';

export type LeadSubmitV5SuccessResponse = {
  status: 'success';
  submissionId: string;
};

export type LeadSubmitV5ErrorResponse = {
  status: 'error';
  code: LeadSubmitV5ErrorCode;
  fieldErrors?: LeadSubmitV5FieldError[];
};

export type LeadSubmitV5BffResponse =
  | LeadSubmitV5SuccessResponse
  | LeadSubmitV5ErrorResponse;
